import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BaseLayout from "./Components/BaseLayout";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Contact from "./Components/Contact";
import Intergration from "./Components/ProductSlider";
import Partner from "./Components/Partner";
import ServiceNowSummitDC from "./Components/ServiceNowSummitDC";
import Solutions from "./Components/Solutions";
import Products from "./Components/Products";
import Appointment from "./Components/Appointment";
import Resources from "./Components/Resources";
import VisitorCounter from "./Components/VisitorCounter";
import VisitorTracker from "./Components/VisitorTracker";
import SEO from "./Components/SEO";
import SponserTicket from "./Components/SponserTicket";
import RegisterForm from "./Components/RegisterForm";
import JobRegisteration from "./Components/Registeration/JobRegisteration";
import SnConfirmationForm from "./Components/Registeration/SnConfirmationForm";
import CharmhealthQuickbooksPage from "./Components/CharmhealthQuickbooksPage";
import Snustpn from "./Components/Registeration/Snustpn";

import ServiceNowWashingtonDC from "./Components/ServiceNow/ServiceNowWashingtonDC";

import ZohoCards from "./Components/Zoho/ZohoCards";
import AnnouncementBar from "./Components/Announcement/AnnouncementBar";
import LeadModal from "./Components/LeadModel";
function App() {
  return (
    <>
      <Router basename="/">
        <div className="container-fluid">
          <div className="container">
            {/* <AnnouncementBar /> */}
            <Header />
            <VisitorTracker />
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <SEO
                      title="Tiara, a software company | ServiceNow Partner"
                      description="Offer CRM, Data Engineering Solutions"
                      keywords="ServiceNow Partner, Service CRM, Sales CRM, Agentic AI, Artificial Intelligence, Data Engineering, ERP Solutions, Cloud Solutions, IT Consulting, Digital Transformation, Tiara Software"
                      url="https://www.tiara.software/"
                      image="https://www.tiara.software/logo192.png"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "@id": "https://www.tiara.software/#website",
                        name: "Tiara Software",
                        url: "https://www.tiara.software/",
                        description:
                          "Tiara Software provides ServiceNow consulting, CRM, ERP, AI, Cloud and Integration solutions.",
                        publisher: {
                          "@type": "Organization",
                          name: "Tiara Software",
                          url: "https://www.tiara.software",
                          logo: {
                            "@type": "ImageObject",
                            url: "https://www.tiara.software/logo192.png",
                          },
                        },
                      }}
                    />
                    <BaseLayout />
                  </>
                }
              />

              <Route
                path="/contact"
                element={
                  <>
                    <SEO
                      title="Contact Tiara Software | ServiceNow, Service CRM & Agentic AI"
                      description="Get in touch with Tiara Software, the leading ServiceNow Partner in DC. Contact us for Service CRM, Sales CRM, and Agentic AI solutions tailored for your business."
                      keywords="Contact Tiara, Contact Tiara Software, ServiceNow Consulting, CRM Consulting, Sales CRM Support, Service CRM Solutions, AI Consulting, ERP Consulting, Cloud Services"
                      url="https://www.tiara.software/contact"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "ContactPage",
                        "@id": "https://www.tiara.software/contact",
                        url: "https://www.tiara.software/contact",
                        name: "Contact Tiara Software",
                        description:
                          "Contact Tiara Software for ServiceNow, CRM, ERP, AI, Cloud, Integration and Digital Transformation consulting services.",
                        mainEntity: {
                          "@type": "Organization",
                          name: "Tiara Software",
                          url: "https://www.tiara.software",
                          logo: "https://www.tiara.software/logo192.png",

                          contactPoint: [
                            {
                              "@type": "ContactPoint",
                              telephone: "+91-9344931575",
                              areaServed: "IN",
                              availableLanguage: ["English", "Tamil"],
                            },
                            {
                              "@type": "ContactPoint",
                              telephone: "+91-9344931577",
                              areaServed: "IN",
                              availableLanguage: ["English", "Tamil"],
                            },
                            {
                              "@type": "ContactPoint",
                              telephone: "+65-6423-0030",
                              areaServed: "SG",
                              availableLanguage: ["English"],
                            },
                            {
                              "@type": "ContactPoint",
                              telephone: "+1-202-394-2630",
                              areaServed: "US",
                              availableLanguage: ["English"],
                            },
                          ],
                          sameAs: ["https://www.linkedin.com/in/tiarasoftware"],
                        },
                      }}
                    />
                    <Contact />
                  </>
                }
              />

              <Route
                path="/resources"
                element={
                  <>
                    <SEO
                      title="Tiara Software Resources | ServiceNow, CRM & AI Insights"
                      description="Explore Tiara Software resources: guides, blogs, and insights on ServiceNow, Service CRM, Sales CRM, and Agentic AI solutions for enterprises."
                      keywords="ServiceNow Resources, Tiara Software Resources, Tiara Resource, Tiara Lastest Events, Tiara Consulting, Agentic AI Service Desk"
                      url="https://www.tiara.software/resources"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@graph": [
                          {
                            "@type": "Organization",
                            "@id": "https://www.tiara.software/#organization",
                            name: "Tiara Software",
                            url: "https://www.tiara.software",
                            logo: {
                              "@type": "ImageObject",
                              url: "https://www.tiara.software/logo192.png",
                            },
                          },

                          {
                            "@type": "Blog",
                            "@id": "https://www.tiara.software/resources#blog",
                            url: "https://www.tiara.software/resources",
                            name: "Tiara Software Resources",
                            headline: "Latest Resources, Events and Training",
                            description:
                              "Explore Tiara Software's latest events, ServiceNow training programs, Agentic AI presentations, technical resources and enterprise digital transformation insights.",

                            publisher: {
                              "@id": "https://www.tiara.software/#organization",
                            },

                            inLanguage: "en",

                            keywords: [
                              "ServiceNow",
                              "Agentic AI",
                              "Enterprise Integration",
                              "Digital Transformation",
                              "CRM",
                              "ERP",
                              "ITSM",
                              "CSM",
                              "HRSD",
                              "Training",
                            ],

                            about: [
                              {
                                "@type": "Thing",
                                name: "ServiceNow",
                              },
                              {
                                "@type": "Thing",
                                name: "Agentic AI",
                              },
                              {
                                "@type": "Thing",
                                name: "Enterprise Integration",
                              },
                            ],
                          },

                          {
                            "@type": "Event",
                            "@id":
                              "https://www.tiara.software/resources#servicenow-training",

                            name: "Specialized Training to get Certified in ServiceNow",

                            description:
                              "Training by ServiceNow Certified Experts covering Functional, Technical and User tracks.",

                            startDate: "2026-04-29T09:00:00+05:30",
                            endDate: "2026-04-29T17:00:00+05:30",

                            eventStatus: "https://schema.org/EventScheduled",

                            eventAttendanceMode:
                              "https://schema.org/OnlineEventAttendanceMode",

                            location: {
                              "@type": "VirtualLocation",
                              url: "https://www.tiara.software/resources",
                            },

                            image: ["https://www.tiara.software/training.jpg"],

                            organizer: {
                              "@id": "https://www.tiara.software/#organization",
                              url: "https://www.tiara.software",
                            },

                            performer: {
                              "@type": "Organization",
                              name: "Tiara Software",
                            },

                            offers: {
                              "@type": "Offer",
                              url: "https://www.tiara.software/resources",
                              price: "0",
                              priceCurrency: "USD",
                              availability: "https://schema.org/InStock",
                              validFrom: "2026-01-01T00:00:00+05:30",
                            },
                          },

                          {
                            "@type": "Event",
                            "@id":
                              "https://www.tiara.software/resources#agentic-ai-service-desk",

                            name: "Tiara Consulting | Agentic AI Service Desk",

                            description:
                              "Live Voice Orchestration for ITSM, CSM and HRSD automation including Password Reset use cases.",

                            startDate: "2025-09-23T00:45:00-04:00",
                            endDate: "2025-09-23T01:15:00-04:00",

                            eventStatus: "https://schema.org/EventScheduled",

                            eventAttendanceMode:
                              "https://schema.org/OfflineEventAttendanceMode",

                            location: {
                              "@type": "Place",
                              name: "Marriott Marquis Washington D.C.",
                              address: {
                                "@type": "PostalAddress",
                                addressLocality: "Washington",
                                addressRegion: "DC",
                                addressCountry: "US",
                              },
                            },

                            image: [
                              "https://www.tiara.software/agentic-ai-event.jpg",
                            ],

                            organizer: {
                              "@id": "https://www.tiara.software/#organization",
                              url: "https://www.tiara.software",
                            },

                            performer: {
                              "@type": "Organization",
                              name: "Tiara Software",
                            },

                            offers: {
                              "@type": "Offer",
                              url: "https://www.tiara.software/resources",
                              price: "0",
                              priceCurrency: "USD",
                              availability: "https://schema.org/InStock",
                              validFrom: "2025-08-01T00:00:00-04:00",
                            },
                          },
                        ],
                      }}
                    />
                    <Resources />
                  </>
                }
              />

              <Route
                path="/integration"
                element={
                  <>
                    <SEO
                      title="ServiceNow & CRM Integration | Tiara Software"
                      description="Tiara Software offers seamless integration services for ServiceNow, Service CRM, Sales CRM, and Agentic AI to improve business processes and digital workflows."
                      keywords="System Integration, ServiceNow Integration, CRM Integration, ERP Integration, API Integration, Data Integration, Cloud Integration, Enterprise Integration"
                      url="https://www.tiara.software/integration"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "@id": "https://www.tiara.software/integration",
                        url: "https://www.tiara.software/integration",
                        name: "Enterprise Integration Services",
                        description:
                          "Tiara Software provides enterprise integration services connecting CRM, ERP, Healthcare, Accounting, Messaging and Business Applications.",

                        serviceType: "Enterprise System Integration",

                        provider: {
                          "@type": "Organization",
                          name: "Tiara Software",
                          url: "https://www.tiara.software",
                          logo: "https://www.tiara.software/logo192.png",
                        },

                        audience: {
                          "@type": "BusinessAudience",
                          audienceType: "Businesses",
                        },

                        category: [
                          "TallyPrime Integration",
                          "ZohoBooks Integration",
                          "QuickBooks Integration",
                          "WhatsApp Integration",
                        ],

                        hasOfferCatalog: {
                          "@type": "OfferCatalog",
                          name: "Integration Services",
                          itemListElement: [
                            {
                              "@type": "Offer",
                              itemOffered: {
                                "@type": "Service",
                                name: "TallyPrime Integration",
                                description:
                                  "Integrates Zoho CRM with QuickBooks Online.",
                              },
                            },
                            {
                              "@type": "Offer",
                              itemOffered: {
                                "@type": "Service",
                                name: "ZohoBooks Integration",
                                description:
                                  "Streamlines invoicing, inventory, CRM and payments.",
                              },
                            },
                            {
                              "@type": "Offer",
                              itemOffered: {
                                "@type": "Service",
                                name: "QuickBooks Integration",
                                description:
                                  "Synchronizes accounting with CRM, payroll and inventory.",
                              },
                            },
                            {
                              "@type": "Offer",
                              itemOffered: {
                                "@type": "Service",
                                name: "WhatsApp Integration",
                                description:
                                  "Connects WhatsApp with CRM and customer support platforms.",
                              },
                            },
                          ],
                        },

                        offers: {
                          "@type": "Offer",
                          availability: "https://schema.org/InStock",
                        },
                      }}
                    />
                    <Intergration />
                  </>
                }
              />

              <Route
                path="/partner"
                element={
                  <>
                    <SEO
                      title="Tiara Software Partners | ServiceNow & CRM Solutions"
                      description="Learn about Tiara Software’s partnership programs for ServiceNow, Service CRM, Sales CRM, and Agentic AI. Collaborate with a trusted IT consulting provider in DC."
                      keywords="ServiceNow Partner, Microsoft Partner, Oracle NetSuite Partner, Zoho Partner, Tally Partner, Technology Partners, Enterprise Solutions"
                      url="https://www.tiara.software/partner"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "AboutPage",
                        "@id": "https://www.tiara.software/partner",
                        url: "https://www.tiara.software/partner",
                        name: "Technology Partners",
                        description: "Technology partners of Tiara Software.",
                        mentions: [
                          {
                            "@type": "Organization",
                            name: "ServiceNow Partner",
                          },
                          {
                            "@type": "Organization",
                            name: "Microsoft Cloud Solution Provider",
                          },
                          {
                            "@type": "Organization",
                            name: "Oracle NetSuite SDN Partner",
                          },
                          {
                            "@type": "Organization",
                            name: "Zoho Authorized Partner",
                          },
                          {
                            "@type": "Organization",
                            name: "Tally Partner",
                          },
                        ],
                      }}
                    />
                    <Partner />
                  </>
                }
              />

              <Route
                path="/whatsnew"
                element={
                  <>
                    <SEO
                      title="What’s New at Tiara Software | ServiceNow & CRM Updates"
                      description="Stay updated with Tiara Software’s latest news, ServiceNow innovations, Service CRM and Sales CRM enhancements, and Agentic AI developments."
                      keywords="ServiceNow News, AI Updates, CRM Updates, ERP News, Tiara Software News, Technology Updates, Digital Transformation"
                      url="https://www.tiara.software/whatsnew"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <ServiceNowSummitDC />
                  </>
                }
              />

              <Route
                path="/solutions"
                element={
                  <>
                    <SEO
                      title="Tiara Software Solutions | ServiceNow, CRM & Agentic AI"
                      description="Discover Tiara Software’s IT solutions including ServiceNow consulting, Service CRM, Sales CRM, and Agentic AI to accelerate your digital transformation."
                      keywords="Business Solutions, Service CRM, Sales CRM, Artificial Intelligence, Agentic AI, ERP Solutions, Data Engineering, Cloud Solutions, ServiceNow Solutions"
                      url="https://www.tiara.software/solutions"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "https://www.tiara.software/solutions",
                        url: "https://www.tiara.software/solutions",
                        name: "Business Solutions",
                        description:
                          "Enterprise business solutions from Tiara Software.",
                        about: [
                          {
                            "@type": "Service",
                            name: "Sales / Service CRM",
                          },
                          {
                            "@type": "Service",
                            name: "Artificial Intelligence Solutions",
                          },
                          {
                            "@type": "Service",
                            name: "Enterprise Resource Planning",
                          },
                          {
                            "@type": "Service",
                            name: "Data Integration",
                          },
                          {
                            "@type": "Service",
                            name: "Cloud Platforms",
                          },
                        ],
                      }}
                    />
                    <Solutions />
                  </>
                }
              />

              <Route
                path="/products"
                element={
                  <>
                    <SEO
                      title="Tiara Software Products | Service CRM & Agentic AI Tools"
                      description="Explore Tiara Software products: Service CRM, Sales CRM, and Agentic AI tools designed for IT consulting and enterprise automation."
                      keywords="Tiara Timesheet, Tiara Integration, Tiara Integration Product Suite, Centroid Dealer Management, Enterprise Products, CRM Products, AI Products, Business Automation, Software Solutions"
                      url="https://www.tiara.software/products"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "https://www.tiara.software/products",
                        url: "https://www.tiara.software/products",
                        name: "Enterprise Software Products",
                        description:
                          "Enterprise software products from Tiara Software.",
                        hasPart: [
                          {
                            "@type": "SoftwareApplication",
                            name: "Centroid Dealer Management",
                            applicationCategory: "BusinessApplication",
                          },
                          {
                            "@type": "SoftwareApplication",
                            name: "Tiara Timesheet",
                            applicationCategory: "BusinessApplication",
                          },
                          {
                            "@type": "SoftwareApplication",
                            name: "Tiara Integration Product Suite",
                            applicationCategory: "Integration Platform",
                          },
                        ],
                      }}
                    />
                    <Products />
                  </>
                }
              />

              <Route
                path="/appointment"
                element={
                  <>
                    <SEO
                      title="Book Appointment | Tiara Software ServiceNow & CRM Consulting"
                      description="Schedule a consultation with Tiara Software, a trusted ServiceNow Partner in DC. Discuss Service CRM, Sales CRM, and Agentic AI solutions for your business."
                      keywords="Book Appointment, Schedule Consultation, ServiceNow Consulting, CRM Consulting, ERP Consulting, AI Consultation, Contact Tiara Software"
                      url="https://www.tiara.software/appointment"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <Appointment />
                  </>
                }
              />

              <Route
                path="/visitor"
                element={
                  <>
                    <SEO
                      title="Visitor Counter | Tiara Software"
                      description="Track the number of visitors to Tiara Software, a leading ServiceNow Partner in DC offering Service CRM, Sales CRM, and Agentic AI solutions."
                      keywords="Website Visitor Counter, Visitor Analytics, Website Statistics, Visitor Tracking"
                      url="https://www.tiara.software/visitor"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <VisitorCounter />
                  </>
                }
              />

              <Route path="/sponserTicket" element={<SponserTicket />} />

              <Route
                path="/sn-ustpn"
                element={
                  <>
                    <SEO
                      title="ServiceNow Training Registration | Tiara Software"
                      description="Register for ServiceNow training with Tiara Software, a trusted ServiceNow Partner in DC. Enhance your skills in Service CRM, Sales CRM, and Agentic AI."
                      keywords="ServiceNow Training, ServiceNow Certification, ITSM Training, ServiceNow Partner Training, Enterprise Training"
                      url="https://www.tiara.software/sn-ustpn"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <Snustpn />
                  </>
                }
              />

              <Route
                path="/apply4job"
                element={
                  <>
                    <SEO
                      title="Job Registration | Tiara Software Careers"
                      description="Apply for job opportunities at Tiara Software, a leading ServiceNow Partner in DC. Join our team and contribute to Service CRM, Sales CRM, and Agentic AI solutions."
                      keywords="Tiara Careers, IT Jobs, Software Jobs, ServiceNow Jobs, React Developer Jobs, Java Developer Jobs, AI Careers"
                      url="https://www.tiara.software/apply4job"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@type": "WebPage",
                        "@id": "https://www.tiara.software/apply4job",
                        url: "https://www.tiara.software/apply4job",
                        name: "Careers | Tiara Software",
                        headline: "Apply for Careers at Tiara Software",
                        description:
                          "Apply for career opportunities at Tiara Software in ServiceNow, AI, ERP, CRM, Enterprise Integration, Cloud, Software Development and QA Automation.",
                        mainEntity: {
                          "@type": "Organization",
                          name: "Tiara Software",
                          url: "https://www.tiara.software",
                          logo: "https://www.tiara.software/logo192.png",
                          sameAs: ["https://www.linkedin.com/in/tiarasoftware"],
                        },
                      }}
                    />
                    <JobRegisteration />
                  </>
                }
              />

              <Route
                path="/snconfirmation"
                element={
                  <>
                    <SEO
                      title="ServiceNow Training Confirmation | Tiara Software"
                      description="Confirm your ServiceNow training registration with Tiara Software, a trusted ServiceNow Partner in DC. Get ready to enhance your skills in Service CRM, Sales CRM, and Agentic AI."
                      keywords="ServiceNow Registration Confirmation, Training Confirmation, ServiceNow Course"
                      url="https://www.tiara.software/snconfirmation"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <SnConfirmationForm />
                  </>
                }
              />
              {/* <Route
            path="/charmhealth-quickbooks"
            element={
              <>
                <SEO
                  title="Charmhealth QuickBooks Integration | Tiara Software"
                  description="Streamline healthcare and accounting workflows with secure Charmhealth – QuickBooks integration and data automation services."
                  url="https://www.tiara.software/charmhealth-quickbooks"
                  image="https://www.tiara.software/bannerCard.jpg"
                />
                <CharmhealthQuickbooksPage />
              </>
            }
          /> */}

              <Route
                path="/zoho-products"
                element={
                  <>
                    <SEO
                      title="Zoho Products | Tiara Software"
                      description="Explore Zoho products and their integration with Tiara Software's automation services."
                      keywords="Zoho CRM, Zoho One, Zoho Books, Zoho Creator, Zoho Partner, Zoho Implementation, Zoho Consulting"
                      url="https://www.tiara.software/zoho-products"
                      image="https://www.tiara.software/bannerCard.jpg"
                    />
                    <ZohoCards />
                  </>
                }
              />
               <Route
                path="/boothvisitor"
                element={
                 
                    
                    <LeadModal />
      
                }
              />
              
              <Route
                path="/boothvistor"
                element={
                    <LeadModal />
                }
              />

              <Route
                path="/servicenow-partner-washington-dc"
                element={
                  <>
                    <SEO
                      title="ServiceNow Partner in Washington, DC | Tiara Software"
                      description="Tiara Software is a ServiceNow Partner serving Washington, DC organizations with ServiceNow consulting, implementation, integration, application development, AI solutions, support, and training."
                      keywords="ServiceNow Partner Washington DC, ServiceNow Consulting Washington DC, ServiceNow Implementation Washington DC, ServiceNow Integration, ServiceNow Application Development, ServiceNow Training, ServiceNow AI, ServiceNow Support"
                      url="https://www.tiara.software/servicenow-partner-washington-dc"
                      image="https://www.tiara.software/bannerCard.jpg"
                      schema={{
                        "@context": "https://schema.org",
                        "@graph": [
                          {
                            "@type": "Organization",
                            "@id": "https://www.tiara.software/#organization",
                            name: "Tiara Software",
                            url: "https://www.tiara.software/",
                            logo: {
                              "@type": "ImageObject",
                              url: "https://www.tiara.software/bannerCard.jpg",
                            },
                          },

                          {
                            "@type": "WebPage",
                            "@id":
                              "https://www.tiara.software/servicenow-partner-washington-dc#webpage",
                            url: "https://www.tiara.software/servicenow-partner-washington-dc",
                            name: "ServiceNow Partner in Washington, DC | Tiara Software",
                            description:
                              "Tiara Software is a ServiceNow Partner serving Washington, DC organizations with ServiceNow consulting, implementation, integration, application development, AI solutions, support, and training.",
                            dateModified: "2026-08-18",
                            isPartOf: {
                              "@id": "https://www.tiara.software/#website",
                            },
                            about: {
                              "@id":
                                "https://www.tiara.software/servicenow-partner-washington-dc#servicenow-service",
                            },
                            publisher: {
                              "@id": "https://www.tiara.software/#organization",
                            },
                            primaryImageOfPage: {
                              "@type": "ImageObject",
                              url: "https://www.tiara.software/bannerCard.jpg",
                            },
                          },

                          {
                            "@type": "Service",
                            "@id":
                              "https://www.tiara.software/servicenow-partner-washington-dc#servicenow-service",
                            name: "ServiceNow Consulting, Implementation & Development Services",
                            serviceType: [
                              "ServiceNow Consulting",
                              "ServiceNow Implementation",
                              "ServiceNow Integration",
                              "ServiceNow Application Development",
                              "ServiceNow AI Solutions",
                              "ServiceNow Support",
                              "ServiceNow Training",
                            ],
                            description:
                              "ServiceNow consulting, implementation, integration, application development, AI solutions, support and training services provided by Tiara Software.",
                            provider: {
                              "@id": "https://www.tiara.software/#organization",
                            },
                            areaServed: {
                              "@type": "City",
                              name: "Washington",
                              containedInPlace: {
                                "@type": "AdministrativeArea",
                                name: "District of Columbia",
                              },
                            },
                          },

                          {
                            "@type": "BreadcrumbList",
                            "@id":
                              "https://www.tiara.software/servicenow-partner-washington-dc#breadcrumb",
                            itemListElement: [
                              {
                                "@type": "ListItem",
                                position: 1,
                                name: "Home",
                                item: "https://www.tiara.software/",
                              },
                              {
                                "@type": "ListItem",
                                position: 2,
                                name: "ServiceNow Partner in Washington, DC",
                                item: "https://www.tiara.software/servicenow-partner-washington-dc",
                              },
                            ],
                          },

                          {
                            "@type": "FAQPage",
                            "@id":
                              "https://www.tiara.software/servicenow-partner-washington-dc#faq",
                            url: "https://www.tiara.software/servicenow-partner-washington-dc",
                            mainEntity: [
                              {
                                "@type": "Question",
                                name: "What does a ServiceNow partner do?",
                                acceptedAnswer: {
                                  "@type": "Answer",
                                  text: "A ServiceNow partner helps organizations plan, implement, configure, customize, integrate and optimize ServiceNow solutions based on their business requirements.",
                                },
                              },
                              {
                                "@type": "Question",
                                name: "What ServiceNow implementation services does Tiara Software provide?",
                                acceptedAnswer: {
                                  "@type": "Answer",
                                  text: "Tiara Software provides ServiceNow implementation services covering platform planning, configuration, customization, integrations, deployment and optimization.",
                                },
                              },
                              {
                                "@type": "Question",
                                name: "Does Tiara Software provide ServiceNow application development?",
                                acceptedAnswer: {
                                  "@type": "Answer",
                                  text: "Yes. Tiara Software provides ServiceNow application development and customization capabilities, including custom applications designed to extend the ServiceNow platform and address specific business requirements.",
                                },
                              },
                              {
                                "@type": "Question",
                                name: "Does Tiara Software provide ServiceNow training?",
                                acceptedAnswer: {
                                  "@type": "Answer",
                                  text: "Yes. Tiara Software provides ServiceNow training programs covering areas such as ServiceNow Administration, ServiceNow Development, ServiceNow Business Analysis and ServiceNow AI.",
                                },
                              },
                              {
                                "@type": "Question",
                                name: "Does Tiara Software serve organizations outside Washington, DC?",
                                acceptedAnswer: {
                                  "@type": "Answer",
                                  text: "Yes. Tiara Software supports organizations with ServiceNow consulting, implementation, integration, application development, AI solutions, support and training requirements in Washington, DC and other locations.",
                                },
                              },
                            ],
                          },
                        ],
                      }}
                    />
                    <ServiceNowWashingtonDC />
                  </>
                }
              />
            </Routes>

            <Footer />
          </div>
        </div>
      </Router>
    </>
  );
}
export default App;
